import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import PluginList from './PluginList';
import PluginShop from './PluginShop';
import PurchasePage from './PurchasePage';
import { PluginShopProvider } from './usePluginShop';

const Index = (props) => (
  <PluginShopProvider>
    <Router>
      <Switch>
        <Route path="/shop/plugin" exact>
          <PluginList {...props} />
        </Route>
        <Route path="/shop/plugin/payment">
          <PurchasePage {...props} />
        </Route>
        <Route path="/shop/plugin/:plugin_name">
          <PluginShop {...props} />
        </Route>
      </Switch>
    </Router>
  </PluginShopProvider>
);

export default Index;
